(function() {
    "use strict";

    taillightUx.directive('tuxNavbarOption', TuxNavBarOption);

    function TuxNavBarOption() {

        return {
            require: "^?tuxNavbar",
            // This will skip all directives on the element that come after it.
            terminal: true,
            link: postLink,
            scope: { }

        }

        function postLink(scope, element, attr, ctrl) {

            if (!ctrl) return;

            var option = element[0];

            var show = ctrl.isAuthorized(option.attributes["routeurl"].value);

            if (option) {

                if (show != false) {

                    ctrl.insertOption({
                        text: option.innerHTML,
                        routeUrl: option.attributes["routeurl"].value,
                        iconClass: option.attributes["iconClass"].value
                    });
                }
                angular.element(option).remove();
            }
        }
    };


    taillightUx.directive('tuxNavbar', TuxNavBar);

    function TuxNavBar() {

        return {
            template: function(element, attr) {

                attr["$tuxNavbarTemplate"] = getTemplate();

                return  '<md-content class="tux-navbar">' +
                        '<nav>' +
                        '<tux-navbar-item ng-repeat="option in ctrl.options">' +
                        '<div ng-click="ctrl.navigate(option.routeUrl)" layout="row" layout-align="start center">' +
                        '<span class="icon {{option.iconClass}}"></span><a class="option tux-pl20"">{{option.text}}</a>' +
                        '</div>' +
                        '</tux-navbar-item>' +
                        '</nav>' +
                        '</md-content>';

                function getTemplate() {
                    var content = element.eq(0),
                        template = content.length ? content.html() : '';
                    return template;
                }
            },
            restrict: 'E',
            controller: ['$scope', '$element', '$attrs', '$compile', navbarController],
            controllerAs: 'ctrl',
            scope: { navigate: "&",
                     isAuthorized: "&",
                     authorization: "="
                   }
        }
    }

    var navbarController = function ($scope, $element, $attrs, $compile) {

        var ctrl = this;

        ctrl.scope = $scope;
        ctrl.parent = $scope.$parent;
        ctrl.options = [];
        ctrl.insertOption = insertOption;
        ctrl.navigate = navigate;
        ctrl.isAuthorized = isAuthorized;

        init();

        function init () {
            ctrl.scope.$watch( 'authorization', function() {
                compileTemplate();
            });
        }

        function compileTemplate () {
            var template = $attrs.$tuxNavbarTemplate;
            // Empty array.
            ctrl.options.length = 0;
            $element.append(template);
            $compile($element.contents())(ctrl.parent);
        }

        function insertOption (option) {
            ctrl.options.push(option);
        }

        function navigate(urlPath) {
            ctrl.scope.navigate( { urlPath: urlPath } );
        }

        function isAuthorized(urlPath) {
            return ctrl.scope.isAuthorized( { urlPath: urlPath } );
        }
    };

}());
